import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from '@services/baseQueryWithReAuth';

import { Contact, LightMessage, MessageRenderRequest, MessageRenderResponse } from '@/types/chat/chat.types';

export const CHAT_URL = import.meta.env.VITE_CHAT_URL;

export const chatApi = createApi({
  reducerPath: 'chatApi',
  baseQuery: baseQueryWithReAuth,
  endpoints: (builder) => ({
    updateContactsByPlatform: builder.mutation<Contact[], { site: string; platformCode: string; contacts: Contact[] }>({
      query: ({ site, platformCode, contacts }) => ({
        url: `${CHAT_URL}/contacts/platform`,
        method: 'PATCH',
        params: { site, platformCode },
        body: contacts,
      }),
    }),
    deleteAllContactsByPlatform: builder.mutation<void, { site: string; platformCode: string }>({
      query: ({ site, platformCode }) => ({
        url: `${CHAT_URL}/contacts/platform`,
        method: 'DELETE',
        params: { site, platformCode },
      }),
    }),
    createMessage: builder.mutation<void, LightMessage>({
      query: (message) => ({
        url: `${CHAT_URL}/messages/global`,
        method: 'POST',
        body: message,
      }),
    }),
    createInstruction: builder.mutation<void, LightMessage>({
      query: (message) => ({
        url: `${CHAT_URL}/messages/instruction`,
        method: 'POST',
        body: message,
      }),
    }),
    renderMessageTemplate: builder.query<MessageRenderResponse, MessageRenderRequest>({
      query: ({ id, ...body }) => ({
        url: `${CHAT_URL}/message-requests/${id}/render`,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useUpdateContactsByPlatformMutation,
  useDeleteAllContactsByPlatformMutation,
  useCreateMessageMutation,
  useCreateInstructionMutation,
  useRenderMessageTemplateQuery,
} = chatApi;
